/* global axios */
// Workspace (26/08): Mapas (canvas estilo Miro) e Drive (arquivos da conta).
// Dois clients no mesmo arquivo de propósito — são o mesmo domínio (menu
// Workspace); o eslint de 1-classe-por-arquivo não se aplica aqui.
/* eslint-disable max-classes-per-file */
import ApiClient from './ApiClient';

class PlanningMapsAPI extends ApiClient {
  constructor() {
    super('planning_maps', { accountScoped: true });
  }

  create(map = {}) {
    return axios.post(this.url, { planning_map: map });
  }

  update(id, map) {
    return axios.patch(`${this.url}/${id}`, { planning_map: map });
  }
}

class DriveFilesAPI extends ApiClient {
  constructor() {
    super('drive_files', { accountScoped: true });
  }

  // scope: 'folder' (default) | 'recent' | 'starred' | 'trash'
  list({ folderId, scope } = {}) {
    return axios.get(this.url, {
      params: { folder_id: folderId || undefined, scope: scope || undefined },
    });
  }

  deletePermanent(id) {
    return axios.delete(`${this.url}/${id}`, {
      params: { permanent: 'true' },
    });
  }

  upload(file, folderId) {
    const formData = new FormData();
    formData.append('file', file);
    if (folderId) formData.append('folder_id', folderId);
    return axios.post(this.url, formData);
  }

  update(id, attrs) {
    return axios.patch(`${this.url}/${id}`, { drive_file: attrs });
  }

  copy(id) {
    return axios.post(`${this.url}/${id}/copy`);
  }
}

class DriveFoldersAPI extends ApiClient {
  constructor() {
    super('drive_folders', { accountScoped: true });
  }

  create(folder) {
    return axios.post(this.url, { drive_folder: folder });
  }

  update(id, folder) {
    return axios.patch(`${this.url}/${id}`, { drive_folder: folder });
  }
}

export const planningMapsAPI = new PlanningMapsAPI();
export const driveFilesAPI = new DriveFilesAPI();
export const driveFoldersAPI = new DriveFoldersAPI();
